import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const getDefaultState = () => {
    return {
        lastlogin: 0,
        token: null,
        icon: "",
        shopName: "",
        userName: "",
        outlets: [],
        category: [],
        commission: "",
        commissionFilter: "",
        sales: "",
        salesCommission: "",
        state: [],
        staffs:[],
        members:[],
        blockList: [],
        stateTukangShopImage: [],
        stateTukangStaffImage: [],
        stateTukangPostImage: [],
    }
}

export default new Vuex.Store({
    state: getDefaultState(),
    plugins: [createPersistedState()],
    mutations: {
        RESET_STATE (state) {
            Object.assign(state, getDefaultState())
        },
        LOGIN_SUCCESS (state, response) {
            console.log(response)
            state.token = response.token;
            state.icon = response.icon;
            state.shopName = response.shopName;
            state.userName = response.userName;
            state.blockList = response.block;
            state.lastlogin = response.loginDate;
        },
        SET_OUTLET (state, item){
            state.outlets = item;
        },
        SET_STAFF (state, item){
            state.staffs = item;
        },
        SET_MEMBER (state,item){
            state.members = item;
        },
        SET_CATEGORY (state, item){
            state.category = item;
        },
        SET_COMMISSION (state, item){
            state.commission = item;
        },
        SET_COMMISSION_FILTER (state, item){
            state.commissionFilter = item;
        },
        SET_SALES (state, item){
            state.sales = item;
        },
        SET_SALES_COMMISSION (state, item){
            state.salesCommission = item;
        },
        SET_INFO_STATE(state, item){
            state.state = item;
        },
        SET_TUKANG_SHOP_IMAGE(state, item){
            if(state.stateTukangShopImage.length == 0){
                state.stateTukangShopImage.push(item)
            }else{
                const found = state.stateTukangShopImage.some(o=> o.imageID == item.imageID)
                if(found){
                    state.stateTukangShopImage = state.stateTukangShopImage.filter(o=> o.imageID !== item.imageID)
                }
                state.stateTukangShopImage.push(item)
            }
        },
        SET_TUKANG_STAFF_IMAGE(state, item){
            if(state.stateTukangStaffImage.length == 0){
                state.stateTukangStaffImage.push(item)
            }else{
                const found = state.stateTukangStaffImage.some(o=> o.imageID == item.imageID)
                if(found){
                    state.stateTukangStaffImage = state.stateTukangStaffImage.filter(o=> o.imageID !== item.imageID)
                }
                state.stateTukangStaffImage.push(item)
            }
        },
        SET_TUKANG_POST_IMAGE(state, item){
            if(state.stateTukangPostImage.length == 0){
                state.stateTukangPostImage.push(item)
            }else{
                const found = state.stateTukangPostImage.some(o=> o.imageID == item.imageID)
                if(found){
                    state.stateTukangPostImage = state.stateTukangPostImage.filter(o=> o.imageID !== item.imageID)
                }
                state.stateTukangPostImage.push(item)
            }
        },
        RESET_TUKANG_IMAGE(state, item){
            switch(item){
                case"shop":
                    state.stateTukangShopImage = []
                    break;
                case"staff":
                    state.stateTukangStaffImage = []
                    break;
                case"post":
                    state.stateTukangPostImage = []
                    break;
            }
        }
    },
    actions: {
  
    }
})